<mat-card class="change-password-card glass-effect">
  <mat-card-header class="change-password-header">
    <mat-icon (click)="returnToDashboard()" class="back-icon">arrow_back</mat-icon>
    <mat-card-title class="change-password-title">Troca de Senha</mat-card-title>
    <mat-card-subtitle class="change-password-subtitle">Atualize sua senha de acesso</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content class="change-password-content">
    <div class="security-info">
      <mat-icon class="security-icon">security</mat-icon>
      <div class="security-text">
        <strong>Dicas de segurança:</strong>
        <ul>
          <li>Use pelo menos 8 caracteres</li>
          <li>Inclua letras maiúsculas e minúsculas</li>
          <li>Adicione números e símbolos</li>
        </ul>
      </div>
    </div>

    <form [formGroup]="changePasswordForm" class="password-form">
      <div class="form-section">
        <h3 class="section-title">
          <mat-icon>lock</mat-icon>
          Nova Senha
        </h3>

        <mat-form-field appearance="outline" class="password-field">
          <mat-label>Digite a nova senha</mat-label>
          <input
            matInput
            type="password"
            formControlName="newPassword"
            #newPasswordInput
            (input)="onPasswordInput($event)"
            required>
          <mat-icon matPrefix>lock_outline</mat-icon>
          <mat-icon
            matSuffix
            (click)="togglePasswordVisibility('new')"
            class="visibility-icon"
            [class.visible]="showNewPassword">
            {{ showNewPassword ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </mat-form-field>

        <!-- Password Strength Indicator -->
        <div class="password-strength" *ngIf="changePasswordForm.value.newPassword">
          <div class="strength-bar">
            <div
              class="strength-fill"
              [class.weak]="passwordStrength === 'weak'"
              [class.medium]="passwordStrength === 'medium'"
              [class.strong]="passwordStrength === 'strong'"
              [style.width.%]="passwordStrengthPercentage">
            </div>
          </div>
          <span class="strength-text">{{ getPasswordStrengthText() }}</span>
        </div>
      </div>

      <div class="form-section">
        <h3 class="section-title">
          <mat-icon>verified</mat-icon>
          Confirmação
        </h3>

        <mat-form-field appearance="outline" class="password-field">
          <mat-label>Digite novamente a nova senha</mat-label>
          <input
            matInput
            type="password"
            formControlName="confirmNewPassword"
            #confirmPasswordInput
            required>
          <mat-icon matPrefix>lock_outline</mat-icon>
          <mat-icon
            matSuffix
            (click)="togglePasswordVisibility('confirm')"
            class="visibility-icon"
            [class.visible]="showConfirmPassword">
            {{ showConfirmPassword ? 'visibility_off' : 'visibility' }}
          </mat-icon>
          <mat-error *ngIf="!validatePasswords() && changePasswordForm.value.confirmNewPassword">
            {{ getErrorMessage() }}
          </mat-error>
        </mat-form-field>

        <!-- Match Indicator -->
        <div class="match-indicator" *ngIf="changePasswordForm.value.confirmNewPassword">
          <mat-icon
            [class.match]="validatePasswords()"
            [class.no-match]="!validatePasswords()">
            {{ validatePasswords() ? 'check_circle' : 'error' }}
          </mat-icon>
          <span>{{ validatePasswords() ? 'Senhas coincidem' : 'Senhas não coincidem' }}</span>
        </div>
      </div>

      <div class="form-actions">
        <button
          mat-flat-button
          class="save-button"
          (click)="changePassword()"
          [disabled]="!validatePasswords() || changePasswordForm.invalid || isLoading"
          [class.loading]="isLoading">
          <mat-icon *ngIf="!isLoading">save</mat-icon>
          <mat-icon *ngIf="isLoading" class="spin">refresh</mat-icon>
          {{ isLoading ? 'Salvando...' : 'Salvar Nova Senha' }}
        </button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
